import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { colours } from 'themes/default';

export const StyledDiv = styled('div')`
  margin: 16px 0 16px -12px;
`;

export const StyledLink = styled(Link)`
  color: ${colours.Shades.BlueShade40};
  text-decoration: none;
`;

export const StyledSpan = styled('span')`
  margin-left: 4px;
  text-decoration: underline;
`;
